/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../cardr/issuing/model';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "Card": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.cardr.issuing.CardState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "creditLineId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "externalCardId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "applicationFlowId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "activatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "creditLineToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "externalCardHolderId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "panFideliusToken": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.Card) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A corporate card
 * --
 *
 * SOURCE Card @ squareup/corporate_card/resources/card.proto at 11:1
 */
export const Card = $root.lookupType('squareup.corporate_card.resources.Card');
fixType(Card);
Builder.createAndAttachToType(Card);